import { render } from "./ProjectSummary.vue?vue&type=template&id=4c39b195&scoped=true"
import script from "./ProjectSummary.vue?vue&type=script&lang=js"
export * from "./ProjectSummary.vue?vue&type=script&lang=js"

import "./ProjectSummary.vue?vue&type=style&index=0&id=4c39b195&scoped=true&lang=scss"

import exportComponent from "/working_dir/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c39b195"]])

export default __exports__